<template>
    <div class="ui-page">
        <ui-page-header :title="page.title" back="/qgc" back-text="QGC">
            <v-btn v-if="(page.isNew) && $allowed('save')" id="btnSave" color="primary" depressed :loading="dataForm.addLoading" @click="add">Salvar</v-btn>
            <v-btn v-else-if="$allowed('save')" id="btnSave" color="primary" depressed :loading="dataForm.updateLoading" @click="update">Salvar</v-btn>
        </ui-page-header>

        <v-form :readonly="!$allowed('save')" ref="form" v-model="dataForm.validForm">
            <ui-section title="Detalhes">
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field dense label="Nome" v-model="dataset.data.name" required
                            :rules="[$rules.required]" outlined hide-details="auto">
                        </v-text-field>
                    </v-col>
                    
                    <v-col cols="12" sm="6">
                        <v-text-field dense id="registration" label="CPF/CNPJ"
                            v-model="dataset.data.registration" required @input="formatRegistration()"
                                :rules="dataset.data.registration_fictitious ? [$rules.required] : [$rules.required, (dataset.data.registration && dataset.data.registration.length < 15 ? $rules.cpf : $rules.cnpj)]"
                                outlined hide-details="auto"
                                :append-icon="dataset.data.registration_fictitious ? 'mdi-alert-circle' : undefined">
                        </v-text-field>
                        <!-- CPF/CNPJ ficticio: documento desconhecido na importacao. Desmarque ao informar o real. -->
                        <v-switch dense hide-details class="mt-2"
                            v-model="dataset.data.registration_fictitious"
                            color="warning"
                            :label="dataset.data.registration_fictitious ? 'CPF/CNPJ fictício (regularizar antes de pagamentos)' : 'CPF/CNPJ fictício'">
                        </v-switch>
                    </v-col>
                    
                </v-row>
                <v-row>

                    <v-col cols="12" sm="6">
                        <!-- type="email" nao aceita lista: o credor pode ter mais
                             de um endereco, separados por virgula. -->
                        <v-text-field dense label="Email" v-model="dataset.data.email"
                            :rules="[$rules.emailList]" outlined
                            hint="Separe múltiplos e-mails por vírgula" persistent-hint>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field dense label="Telefone" v-model="dataset.data.phone_number" 
                                outlined hide-details="auto">
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="4">   
                        <v-autocomplete dense :items="dataset.clients" label="Caso" v-model="dataset.data.client_id" 
                        item-value="id" item-text="name" outlined hide-details="auto"
                        required :rules="[$rules.required]"  no-data-text="Nenhum caso encontrado"
                        @change="onClientChange">
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4" v-if="clientCompanyOptions.length">
                        <v-select dense :items="clientCompanyOptions" label="Empresa do grupo"
                            v-model="dataset.data.client_company_id" item-value="id" item-text="name"
                            outlined hide-details="auto" clearable
                            no-data-text="Nenhuma empresa encontrada">
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-select dense :items="dataset.creditorTypes" label="Classe" required
                            v-model="dataset.data.type" item-value="id" item-text="name" outlined
                            :disabled="!dataset.data.client_id"
                            :rules="[$rules.required]" hide-details="auto">
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-currency-field label="Valor" dense
                            v-model="dataset.data.amount" :allowNegative=false
                            hide-details="auto" outlined required :rules="[$rules.required]">
                        </v-currency-field>
                    </v-col>
                    
                    <v-col cols="12" sm="2">
                        <v-select dense :items="versionOptions" label="Versão do QGC" required
                            v-model="dataset.data.version" item-value="id" item-text="label" outlined
                            :rules="[$rules.required]" hide-details="auto">
                        </v-select>
                    </v-col>
                </v-row>
            </ui-section>
        </v-form>

        <!-- Rastro de alteracoes do credor: quem mudou, quando, por qual modulo e o que mudou -->
        <ui-section v-if="!page.isNew" title="Histórico de alterações">
            <template #actions>
                <v-btn icon small :loading="history.loading" @click="loadHistory" title="Atualizar"><v-icon small>mdi-refresh</v-icon></v-btn>
            </template>
            <p v-if="!history.loading && !history.items.length" class="grey--text mb-0">
                Nenhuma alteração registrada para este credor. O histórico passou a ser gravado a partir da ativação deste recurso.
            </p>
            <v-simple-table v-else dense>
                <thead>
                    <tr>
                        <th style="width: 150px;">Quando</th>
                        <th style="width: 200px;">Quem</th>
                        <th style="width: 160px;">Origem</th>
                        <th>O que mudou</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="entry in history.items" :key="entry.id" :class="{ 'grey--text': !entry.same_row }">
                        <td>{{ entry.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}</td>
                        <td>
                            {{ entry.admin_name || (entry.user_id ? 'Credor (portal)' : 'Sistema') }}
                        </td>
                        <td>
                            <ui-badge :text="historySourceLabel(entry.source)" tone="neutral" :dot="false" />
                            <div v-if="!entry.same_row" class="text-caption">outra linha do mesmo CPF/CNPJ</div>
                        </td>
                        <td>
                            <span v-if="entry.action === 'delete'" class="error--text">Registro excluído</span>
                            <span v-else-if="entry.action === 'create'">Registro criado<span v-if="historyChangeList(entry).length">: </span>
                                <span v-for="(change, index) in historyChangeList(entry)" :key="index">
                                    <strong>{{ change.label }}</strong> {{ change.to }}<span v-if="index < historyChangeList(entry).length - 1">; </span>
                                </span>
                            </span>
                            <div v-else v-for="(change, index) in historyChangeList(entry)" :key="index">
                                <strong>{{ change.label }}:</strong> {{ change.from }} → {{ change.to }}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
        </ui-section>
    </div>
</template>

<script>
import string from "@/common/util/string"
import creditorTypes from "@/common/data/creditor-types.data"
import creditorClassUtil from "@/common/util/creditor-class.util"
// NOVO IMPORT INJETADO
import qgcVersions from "@/common/data/qgc-versions.data" 
import { cpf, cnpj } from 'cpf-cnpj-validator'

import axios from "axios"

export default {
    name: "QgcDetails",

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        // NOVA LISTA INJETADA
        qgcVersions: qgcVersions,
        // QGCs cadastrados do caso escolhido (inclui versoes >= 4)
        caseVersions: [],
        
        dataset: {
            breadcrumbItems: [],
            data: {  
                registration: "",
                registration_fictitious: false,
                type: null,
                amount: null,
                client_id: null,
                client_company_id: null,
                name: "",
                email: "",
                phone_number: "",
                version: 1 // DEFAULT INJETADO
            },
            clients: [],
            creditorTypes: creditorTypes,
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
        },
        history: {
            loading: false,
            items: [],
        },
    }),

    created() {
        this.loadData()
        this.loadHistory()
    },

    watch: {
        'dataset.data.client_id'(value, oldValue) {
            if (String(value) === String(oldValue)) return;

            this.loadCreditorClasses(value);
            this.loadCaseVersions(value);
        },
    },

    computed: {
        versionOptions() {
            if (this.caseVersions.length) {
                return this.caseVersions.map((item) => ({ id: item.version, label: `v${item.version} · ${item.title}${item.is_current ? ' (vigente)' : ''}` }));
            }
            return this.qgcVersions;
        },

        selectedClient() {
            return this.dataset.clients.find(client => Number(client.id) === Number(this.dataset.data.client_id)) || null;
        },

        clientCompanyOptions() {
            const companies = this.selectedClient && Array.isArray(this.selectedClient.companies)
                ? this.selectedClient.companies
                : [];

            return companies
                .filter(company => company && company.name)
                .map(company => ({ id: company.id, name: company.name }));
        },
    },

    methods: {
        goBack() {
            this.$router.replace("/qgc");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();
            await this.loadClients();
            await this.load();
            await this.loadCreditorClasses(this.dataset.data.client_id);
        },

        async loadHistory() {
            if (this.page.isNew || !this.$route.params.id) return;
            this.history.loading = true;
            try {
                const result = await axios.get(`/api/admin/users-creditors/${this.$route.params.id}/history`);
                this.history.items = result.data.content || [];
            } catch (error) {
                this.history.items = [];
            } finally {
                this.history.loading = false;
            }
        },

        historySourceLabel(source) {
            return ({
                manual: 'Edição manual (QGC)',
                creditor_list: 'Lista de credores',
                oficio: 'Análise de ofício',
                hab_div: 'Hab/Div',
                chc: 'CHC (Certidão de Habilitação de Crédito)',
                central: 'Central de Créditos',
                agc: 'Assembleia (AGC)',
                impugnacao: 'Impugnação',
                consolidation: 'Consolidação do QGC',
                ia: 'Assistente de IA',
                backoffice: 'Backoffice',
                portal: 'Portal do credor',
                system: 'Sistema',
            })[source] || source || 'Sistema';
        },

        historyFieldLabel(field) {
            return ({
                name: 'Nome',
                email: 'E-mail',
                phone_number: 'Telefone',
                registration: 'CPF/CNPJ',
                registration_fictitious: 'CPF/CNPJ fictício',
                amount: 'Valor',
                old_amount: 'Valor anterior',
                type: 'Classe',
                currency: 'Moeda',
                client_company_id: 'Empresa do grupo',
                source_type: 'Origem',
                source_description: 'Descrição da origem',
                source_reference_id: 'Referência da origem',
                user_id: 'Usuário vinculado',
                deleted_at: 'Exclusão',
                version: 'Versão do QGC',
            })[field] || field;
        },

        historyFormatValue(field, value) {
            if (value === null || value === undefined || value === '') return '—';
            if (field === 'amount' || field === 'old_amount') return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            if (field === 'type') {
                const type = this.dataset.creditorTypes.find(item => Number(item.id) === Number(value));
                return type ? type.name : `Classe ${value}`;
            }
            if (field === 'registration_fictitious') return Number(value) ? 'Sim' : 'Não';
            if (field === 'deleted_at') return Number(value) === 0 ? 'Ativo' : 'Excluído';
            return String(value);
        },

        historyChangeList(entry) {
            const changes = entry && entry.changes ? entry.changes : {};
            return Object.keys(changes).map((field) => ({
                label: this.historyFieldLabel(field),
                from: this.historyFormatValue(field, changes[field].from),
                to: this.historyFormatValue(field, changes[field].to),
            }));
        },

        async loadCreditorClasses(clientId) {
            // O select oferece apenas as classes ativas do caso; classes
            // ocultas continuam validas para credores ja classificados.
            this.dataset.creditorTypes = await creditorClassUtil.listByClient(clientId);

            if (!this.dataset.data.type) return;

            const stillExists = this.dataset.creditorTypes
                .some((item) => Number(item.id) === Number(this.dataset.data.type));

            // Ao trocar de caso a classe escolhida pode nao existir no novo,
            // e deixar o valor antigo gravaria uma classe de outro caso.
            if (!stillExists) this.dataset.data.type = null;
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `${this.page.isNew ? 'Novo credor' : 'Detalhes do credor'}`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
                {
                    text: "QGC",
                    disabled: false,
                    to: "/qgc",
                    exact: true,
                },
                {
                    text: this.page.title,
                    disabled: true,
                    exact: true,
                }
            ];
        },

        formatCpfCnpj(value) {
            if (!value) return "";
            return value.length <= 11 ? cpf.format(value) : cnpj.format(value);
        },

        formatRegistration() {
            let rawValue = this.dataset.data.registration.replace(/\D/g, '');
            this.dataset.data.registration = this.formatCpfCnpj(rawValue);
        },

        onClientChange() {
            this.dataset.data.client_company_id = null;
            this.loadCreditorClasses(this.dataset.data.client_id);
        },

        async load() {
            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/admin/users-creditors/${this.$route.params.id}`);
                
                const data = result.data.data || result.data.content;

                this.dataset.data = data;
                this.$set(this.dataset.data, 'registration_fictitious', !!Number(data.registration_fictitious));

                if (data.registration) {
                    this.dataset.data.registration = this.formatCpfCnpj(data.registration.replace(/\D/g, ''));
                }
                
                // FALLBACK DE VERSÃO CASO NÃO VENHA DA API
                if (!this.dataset.data.version) {
                    this.dataset.data.version = 1;
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            }
        },

        async loadCaseVersions(clientId) {
            if (!clientId) { this.caseVersions = []; return; }
            try {
                const result = await axios.get(`/api/admin/clients/${clientId}/qgc-versions`);
                this.caseVersions = (result.data.content && result.data.content.versions) || [];
            } catch (error) {
                this.caseVersions = [];
            }
        },

        async loadClients() {
            try {
                // ROTA ANTIGA MANTIDA
                const result = await axios.get(`/api/clients`, { params: { start: 1, limit: 100000, search: "{}" } });

                const data = result.data.data ? result.data.data.data : result.data.content.data;
                
                data.sort((a, b) => a.name.localeCompare(b.name));
                
                this.dataset.clients = data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            }
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir o QGC?',
                title: 'Incluir QGC',
                actions: { false: 'Cancelar', true: 'Salvar' }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;
            const payload = this.buildPayload();

            try {
                await axios.post('/api/admin/users-creditors', payload);
                this.$dialog.notify.info("QGC salvo com sucesso!", { position: "top-right", timeout: 2000 });
                this.goBack();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar dados do QGC?',
                title: 'Atualizar QGC',
                actions: { false: 'Cancelar', true: 'Atualizar' }
            })

            if (!proceedAction) return;

            this.dataForm.updateLoading = true;
            const payload = this.buildPayload();

            try {
                await axios.patch(`/api/admin/users-creditors/${this.$route.params.id}`, payload);
                this.$dialog.notify.info("QGC atualizado com sucesso!", { position: "top-right", timeout: 2000 });
                this.goBack();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            } finally {
                this.dataForm.updateLoading = false;
            }
        },

        buildPayload() {
            return {
                name: this.dataset.data.name,
                email: this.dataset.data.email,
                type: Number(this.dataset.data.type), 
                amount: Number(this.dataset.data.amount), 
                client_id: Number(this.dataset.data.client_id),
                client_company_id: this.dataset.data.client_company_id ? Number(this.dataset.data.client_company_id) : null,
                phone_number: this.dataset.data.phone_number || null,
                registration: this.dataset.data.registration ? this.dataset.data.registration.replace(/\D/g, '') : null,
                registration_fictitious: !!this.dataset.data.registration_fictitious,
                // CAMPO VERSÃO INJETADO NO PAYLOAD
                version: Number(this.dataset.data.version) 
            };
        },
    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>
